export const _shareClassClass = {
  name: { type: 'string', title: 'Nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  votingpower: { type: 'number', title: 'Äänimäärä' },
}

export const _shareClassUISchema = {}

export const _shareTemplateClass = {
  name: { type: 'string', title: 'Nimi' },
  classId: { type: 'string', title: 'Osakelajit', oneOf: [] },
  properties: {
    type: 'array',
    title: 'Lisätiedot',
    items: {
      type: 'object',
      properties: {
        key: { type: 'string', title: 'Avain' },
        value: { type: 'string', title: 'Arvo' },
      },
    },
  },
}

export const _shareTemplateUISchema = {}

export const _shareholderClass = {
  type: {
    type: 'string',
    title: 'Tyyppi',
    oneOf: [
      { const: 'person', title: 'Henkilö' },
      { const: 'organization', title: 'Organisaatio' },
    ],
  },
  personName: { type: 'string', title: 'Nimi', readOnly: true },
  ssn: { type: 'string', title: 'Henkilötunnus' },
  contactPerson: { type: 'string', title: 'Yhteyshenkilö' },
  phone: { type: 'string', title: 'Puhelin' },
  email: { type: 'string', title: 'Sähköposti', format: 'email' },
}

export const _shareholderClassDeps = {
  type: {
    oneOf: [
      {
        properties: {
          type: { enum: ['person'] },
          ssn: { type: 'string', title: 'Henkilötunnus' },
        },
      },
      {
        properties: {
          type: { enum: ['organization'] },
          contactPerson: { type: 'string', title: 'Yhteyshenkilö' },
        },
      },
    ],
  },
}

export const _shareholderUISchema = {}

export const _shareCertificateClass = {
  name: { type: 'string', title: 'Nimi' },
  templateId: { type: 'string', title: 'Osakepohja', oneOf: [] },
}

export const _shareCertificateUISchema = {}
